var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"description column",attrs:{"title":_vm.item.description}},[_vm._v(" "+_vm._s(_vm.item.description)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }